<template>
  <div>
    <SectionContainer>
      <ContainerMedium>
        <BreadCrumb :crumb="crumb" />

        <section>
          <PrimaryTitle class="title">Área de Ajuda</PrimaryTitle>
          <p class="subtitle">
            Com dúvidas sobre o CyberClass? Então chega mais e entenda quem somos e como podemos ajudar você a <b>conquistar seus sonhos</b>.
          </p>
        </section>

        <hr>

        <section class="section-group">
          <PrimaryTitle
            size="sm"
            class="mb-4"
          >Dúvidas Frequentes</PrimaryTitle>

          <SupportFAQBox />
        </section>

        <section class="section-group" id="contato">
          <h6 class="mb-3">Bora trocar uma ideia?</h6>

          <PrimaryParagraph>
            Ainda com dúvidas? Entre em contato com nossa equipe de suporte.
          </PrimaryParagraph>

          <PrimaryParagraph class="mb-4">
            Nosso <u>chat de suporte</u> atende de <b>segunda a sexta</b> das <b>8h às 19h</b>.
          </PrimaryParagraph>

          <PrimaryParagraph class="mb-4">
            Ou se preferir, nos mande uma mensagem no formulário de contato abaixo.
          </PrimaryParagraph>

          <a href="https://cyberclass.zendesk.com/hc/pt-br/requests/new" target="_blank">
            <SecondaryButton>Ir para o formulário de contato</SecondaryButton>
          </a>
        </section>
      </ContainerMedium>
    </SectionContainer>
  </div>
</template>

<script>
  import PrimaryTitle from '@/components/text/titles/PrimaryTitle'
  import SecondaryButton from '@/components/buttons/SecondaryButton'
  import ContainerMedium from '@/components/layout/containers/ContainerMedium'
  import SectionContainer from '@/components/layout/SectionContainer'
  import PrimaryParagraph from '@/components/text/paragraphs/PrimaryParagraph'
  import SupportFAQBox from '@/components/support/SupportFAQBox'
  import BreadCrumb from '@/components/layout/BreadCrumb'

  export default {
    components: {
      ContainerMedium,
      PrimaryTitle,
      SectionContainer,
      PrimaryParagraph,
      SupportFAQBox,
      BreadCrumb,
      SecondaryButton,
    },

    metaInfo () {
      return { title: 'Área de Ajuda | CyberClass' }
    },

    mounted () {
      this.createZendeskScript()
    },

    beforeDestroy () {
      this.hideZendeskScript()
    },

    computed: {
      crumb () {
        return [{
          label: 'Página Inicial',
          route: { name: 'home' }
        }, {
          label: 'Área de Ajuda'
        }]
      }
    },

    methods: {
      hideZendeskScript () {
        const chat = document.getElementById("launcher")
        if (chat) {
          chat.style.display = 'none'
        }
      },

      createZendeskScript () {
        if (document.getElementById('ze-snippet')) {
          const chat = document.getElementById("launcher")
          if (chat) {
            chat.style.display = 'block'
          }
          return null
        }

        const script = document.createElement('script')
        script.src = 'https://static.zdassets.com/ekr/snippet.js?key=ef92d6bb-0d5a-484a-8bb7-71fe29f2fde7'
        script.setAttribute('id', 'ze-snippet')

        document.head.appendChild(script)
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "~@/assets/sass/variables";

  .title {
    margin: 4px 0;
  }

  .subtitle {
    font-size: 0.89rem;
  }

  .section-group:not(:last-child) {
    margin-bottom: 2.5rem;
    padding-bottom: 2.5rem;
    border-bottom: 1px solid rgba(#000, .1);
  }

  #contato {
    p {
      font-size: 0.89rem;
    }
  }
</style>